import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, of } from "rxjs";
import { About, environment } from "src/index";

@Injectable({
  providedIn: "root",
})
export class AboutService {
  private httpClient = inject(HttpClient);

  getAbout() {
    if (environment.about) {
      return this.httpClient
        .get<About>(environment.about)
        .pipe(catchError(() => of({} as About)));
    }

    return of({} as About);
  }
}
